import { getComponentForType } from "./EmailSectionRegistry";

/**
 * DynamicComponent renders a component based on its component_name property
 * It uses the standardizeComponentProps utility to ensure consistent props structure
 */
const DynamicComponent = (props) => {
  // Removed console.log to prevent infinite loop logging
  // console.log("Raw props received:", JSON.stringify(props, null, 2));

  // If component name is not provided, render nothing
  if (!props.component_name) {
    console.warn(
      "DynamicComponent: No component_name provided in props",
      props
    );
    return null;
  }

  // Create a handler for updates that preserves the component_name
  const handleUpdate = (updatedData, id) => {
    if (props.onUpdate) {
      // Ensure the component_name is carried forward
      const dataWithComponentName = {
        ...updatedData,
        component_name: props.component_name,
      };

      props.onUpdate(dataWithComponentName, id || props.id);
    } else {
      console.warn(
        "DynamicComponent: No onUpdate handler provided",
        props.component_name,
        props.id
      );
    }
  };

  // Get the component for the given type
  const Component = getComponentForType(props.component_name);

  // If component wasn't found, render a placeholder
  if (!Component) {
    console.warn(
      `DynamicComponent: Unknown component type "${props.component_name}"`,
      props
    );
    return (
      <div
        className="component-placeholder"
        style={{ padding: "20px", border: "1px dashed #ccc", margin: "10px 0" }}
      >
        <h4>Unknown Component: {props.component_name}</h4>
        <pre>{JSON.stringify(props, null, 2)}</pre>
      </div>
    );
  }

  // Ensure we have a final component props object with everything the component needs
  // Instead of transforming props, just pass them through directly with onUpdate override
  const componentProps = {
    ...props,
    onUpdate: handleUpdate,
  };
  // Removed console.log to prevent infinite loop logging
  // console.log(
  //   `DynamicComponent (${props.id}) FINAL PROPS passed to ${props.component_name}:`,
  //   JSON.stringify(componentProps, null, 2)
  // );
  // console.log(
  //   "==================== DYNAMIC COMPONENT END ===================="
  // );

  // Render the component with all props and our enhanced onUpdate handler
  return <Component {...componentProps} />;
};

export default DynamicComponent;
